/* PWA bootstrap — registers the service worker and exposes a global
   `beforeinstallprompt` capture so the InstallPrompt component can trigger
   the native install flow on Android/Chrome. */
export function initPWA() {
  if (typeof window === "undefined") return;

  // Register the service worker on every load (no-op if already registered)
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("[Fliboe] SW registration failed:", err);
      });
    });
  }

  // Capture the install prompt so we can fire it from a UI button later
  window.__fliboeInstallEvent = null;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__fliboeInstallEvent = e;
    window.dispatchEvent(new CustomEvent("fliboe:installable"));
  });

  window.addEventListener("appinstalled", () => {
    window.__fliboeInstallEvent = null;
    try { localStorage.setItem("fliboe_installed", "1"); } catch (_) {}
    window.dispatchEvent(new CustomEvent("fliboe:installed"));
  });
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function detectPlatform() {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
}
